import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/utils/cn';
import { range } from '@/utils/range';
function Placeholder() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-10 rounded-full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-xl border p-4"><div className="mb-3 flex gap-3">{t0}<div className="flex flex-col justify-center gap-1"><Skeleton className="h-4 w-40" /><Skeleton className="h-4 w-36" /></div></div><Skeleton className="h-6 w-full max-w-xs pl-13" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function MessagesLoader(props) {
  const $ = _c(9);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex flex-col gap-4", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = range(8).map(_temp);
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== rest || $[7] !== t0) {
    t2 = <div className={t0} {...rest}>{t1}</div>;
    $[6] = rest;
    $[7] = t0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(number) {
  return <Placeholder key={number} />;
}